// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --main-color: rgb(20, 17, 17);
    --card-color: rgb(0, 0, 0);
    --card-border-color: rgb(113, 71, 126);
    --gradient-sides: #7a7a7a;
    --gradient-mid: #ffffff;
}

* {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

body {
    background-color: var(--main-color);
}

header {
    text-align: center;
    color: white;
}

header h1 {
    background: linear-gradient(90deg, var(--gradient-sides) 40%, var(--gradient-mid) 50%, var(--gradient-sides) 60%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

}

#project-container {
    padding: 48px;
    display: flex;
    flex-wrap: wrap;
}

#project-list {
    display: flex;
    flex-wrap: wrap;
}

ul,
li {
    padding: 0px;
    margin: 0px;
    list-style-type: none;
}


#addProjectForm {
    width: 20vw;
    height: 50vh;
    color: black;
    display: flex;
    flex-direction: column;
}

form,
dialog,
fieldset {
    background-color: var(--main-color);
    border: none;
}

label,
legend,
input,
option,
textarea {
    color: white;
}

input::placeholder,
textarea::placeholder {
    color: rgb(248, 248, 248);
}

form input,
form label,
form textarea,
form button {
    padding: .5rem;
    width: 200px;
}

textarea,
input,
select {
    background-color: rgb(36, 36, 36);
}

#addProjectPriority,
#addNotePriority {
    color: white;
}

#addNoteButton,
#addProjectBtn {
    border: solid 2px white;
    margin-right: auto;
}

#addNoteButton:hover,
#addProjectBtn:hover {
    cursor: pointer;
}

.card {
    color: white;
    background: linear-gradient(-30deg, rgba(15, 15, 15, .9) 0%, rgb(0, 0, 0, 0.4) 55%);
    border: solid 2px;
    border-color: var(--card-border-color);
    border-radius: 7px;
    margin-left: 20px;
    padding-left: 10px;
    width: 250px;
    height: 250px;
}

.card header {
    display: flex;
    justify-content: space-between;
    padding: 4px;
}

.delete-project-button,
.delete-note-button {
    position: relative;
    border: solid 1px black;
    border-radius: 5px;
    aspect-ratio: 1;
    height: 48px;
}


.delete-project-button {
    top: -248px;
    left: 230px;
}

.delete-note-button {
    top: 0px;
    left: 0px;
}

.delete-project-button:hover,
.delete-note-button:hover {
    background-color: red;
}

button .card {
    display: flex;
    align-items: center;
    justify-content: center;

}

#projectInfo {
    width: 100vw;
    height: 100vh;
    border: none;
    background-color: rgb(165, 30, 113);
    background-color: var(--main-color);
    opacity: .99;
    color: white;
}

#project-dialog-form {
    width: 100%;
    display: flex;
    flex-direction: column;
}

#projectInfo h2 {
    text-align: center;
}

#projectInfo h3,
h4,
h5 {
    font-size: 18px;
}

#project-dialog-form input {
    width: 400px;
    background-color: rgb(0, 0, 0, 0);
    border: none;
    font-size: 18px;
    color: white;
    font-size: 38px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}

#project-note-container {
    display: flex;
}

#dialog-header {
    display: grid;
    grid-template-columns: 50px 1fr 50px;
}

#exit-button {
    width: min-content;
    height: min-content;
    background-color: rgb(0, 0, 0, 0);
    border: none;
}

#project-note-container {
    padding: 48px;
    display: flex;
    flex-wrap: wrap;
}

#note-list {
    display: flex;
    flex-wrap: wrap;
}

#addNoteDialog form {
    display: flex;
    flex-direction: column;
    width: 350px;
    height: 400px;
}

#addNoteDialog input,
#addNoteDialog textarea {
    width: 90%;
}

#addNoteDialog select {
    width: 50%;
}

a {
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,sCAAsC;IACtC,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iHAAiH;IACjH,6BAA6B;IAC7B,oCAAoC;;AAExC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;IAGI,mCAAmC;IACnC,YAAY;AAChB;;AAEA;;;;;IAKI,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;IACd,YAAY;AAChB;;AAEA;;;IAGI,iCAAiC;AACrC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mFAAmF;IACnF,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mCAAmC;IACnC,mCAAmC;IACnC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[":root {\n    --main-color: rgb(20, 17, 17);\n    --card-color: rgb(0, 0, 0);\n    --card-border-color: rgb(113, 71, 126);\n    --gradient-sides: #7a7a7a;\n    --gradient-mid: #ffffff;\n}\n\n* {\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n\nbody {\n    background-color: var(--main-color);\n}\n\nheader {\n    text-align: center;\n    color: white;\n}\n\nheader h1 {\n    background: linear-gradient(90deg, var(--gradient-sides) 40%, var(--gradient-mid) 50%, var(--gradient-sides) 60%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n\n}\n\n#project-container {\n    padding: 48px;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n#project-list {\n    display: flex;\n    flex-wrap: wrap;\n}\n\nul,\nli {\n    padding: 0px;\n    margin: 0px;\n    list-style-type: none;\n}\n\n\n#addProjectForm {\n    width: 20vw;\n    height: 50vh;\n    color: black;\n    display: flex;\n    flex-direction: column;\n}\n\nform,\ndialog,\nfieldset {\n    background-color: var(--main-color);\n    border: none;\n}\n\nlabel,\nlegend,\ninput,\noption,\ntextarea {\n    color: white;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n    color: rgb(248, 248, 248);\n}\n\nform input,\nform label,\nform textarea,\nform button {\n    padding: .5rem;\n    width: 200px;\n}\n\ntextarea,\ninput,\nselect {\n    background-color: rgb(36, 36, 36);\n}\n\n#addProjectPriority,\n#addNotePriority {\n    color: white;\n}\n\n#addNoteButton,\n#addProjectBtn {\n    border: solid 2px white;\n    margin-right: auto;\n}\n\n#addNoteButton:hover,\n#addProjectBtn:hover {\n    cursor: pointer;\n}\n\n.card {\n    color: white;\n    background: linear-gradient(-30deg, rgba(15, 15, 15, .9) 0%, rgb(0, 0, 0, 0.4) 55%);\n    border: solid 2px;\n    border-color: var(--card-border-color);\n    border-radius: 7px;\n    margin-left: 20px;\n    padding-left: 10px;\n    width: 250px;\n    height: 250px;\n}\n\n.card header {\n    display: flex;\n    justify-content: space-between;\n    padding: 4px;\n}\n\n.delete-project-button,\n.delete-note-button {\n    position: relative;\n    border: solid 1px black;\n    border-radius: 5px;\n    aspect-ratio: 1;\n    height: 48px;\n}\n\n\n.delete-project-button {\n    top: -248px;\n    left: 230px;\n}\n\n.delete-note-button {\n    top: 0px;\n    left: 0px;\n}\n\n.delete-project-button:hover,\n.delete-note-button:hover {\n    background-color: red;\n}\n\nbutton .card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n#projectInfo {\n    width: 100vw;\n    height: 100vh;\n    border: none;\n    background-color: rgb(165, 30, 113);\n    background-color: var(--main-color);\n    opacity: .99;\n    color: white;\n}\n\n#project-dialog-form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n#projectInfo h2 {\n    text-align: center;\n}\n\n#projectInfo h3,\nh4,\nh5 {\n    font-size: 18px;\n}\n\n#project-dialog-form input {\n    width: 400px;\n    background-color: rgb(0, 0, 0, 0);\n    border: none;\n    font-size: 18px;\n    color: white;\n    font-size: 38px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n#project-note-container {\n    display: flex;\n}\n\n#dialog-header {\n    display: grid;\n    grid-template-columns: 50px 1fr 50px;\n}\n\n#exit-button {\n    width: min-content;\n    height: min-content;\n    background-color: rgb(0, 0, 0, 0);\n    border: none;\n}\n\n#project-note-container {\n    padding: 48px;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n#note-list {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n#addNoteDialog form {\n    display: flex;\n    flex-direction: column;\n    width: 350px;\n    height: 400px;\n}\n\n#addNoteDialog input,\n#addNoteDialog textarea {\n    width: 90%;\n}\n\n#addNoteDialog select {\n    width: 50%;\n}\n\na {\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
